import { Link } from 'react-router';

export interface LegalPolicyLinksProps {
  privacyPath?: string;
  cookiesPath?: string;
  termsPath?: string;
  supportEmail?: string | null;
  legalEmail?: string | null;
}

const POLICY_LINKS = [
  {
    key: 'privacy',
    title: 'Privacy Policy',
    description: 'How we collect, use, and protect your information.',
    pathKey: 'privacyPath' as const
  },
  {
    key: 'cookies',
    title: 'Cookie Policy',
    description: 'Cookies, local storage, and consent on this site.',
    pathKey: 'cookiesPath' as const
  },
  {
    key: 'terms',
    title: 'Terms of Use',
    description: 'Rules and conditions for using this application.',
    pathKey: 'termsPath' as const
  }
];

export function LegalPolicyLinks({
  privacyPath = '/settings/privacy',
  cookiesPath = '/settings/cookies',
  termsPath = '/settings/terms',
  supportEmail,
  legalEmail
}: LegalPolicyLinksProps) {
  const paths = { privacyPath, cookiesPath, termsPath };
  const contactLinks = [
    supportEmail ? { label: 'Support', href: `mailto:${supportEmail}` } : null,
    legalEmail ? { label: 'Legal', href: `mailto:${legalEmail}` } : null
  ].filter((item): item is { label: string; href: string } => item !== null);

  return (
    <div className="site-support-legal-links">
      <nav className="site-support-legal-links__grid" aria-label="Legal policies">
        {POLICY_LINKS.map(({ key, title, description, pathKey }) => (
          <Link key={key} to={paths[pathKey]} className="site-support-legal-links__card">
            <span className="site-support-legal-links__card-title">{title}</span>
            <span className="site-support-legal-links__card-desc">{description}</span>
          </Link>
        ))}
      </nav>
      {contactLinks.length > 0 ? (
        <p className="site-support-legal-links__contact">
          Questions?{' '}
          {contactLinks.map((item, index) => (
            <span key={item.label}>
              {index > 0 ? ' · ' : null}
              <a href={item.href}>{item.label}</a>
            </span>
          ))}
        </p>
      ) : null}
    </div>
  );
}
